import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'API Lifecycle Management and Deployment',
                topics: [
                    'API Scalability: Techniques for Handling Large Volumes of API Traffic',
                    'API Management Platforms: Features and Capabilities for Full Lifecycle Management',
                    'CI/CD Pipeline for APIs: Best Practices and Tools for Continuous Delivery',
                    'Usability Testing for APIs: Tips for Creating a User-Friendly API',
                    'Hybrid API Integration: Combining Traditional and Cloud-Native Approaches',
                ],
            },
            {
                title: 'Emerging API Technologies and Design Standards',
                topics: [
                    'IoT API Design: How to Develop APIs for Connected Devices',
                    'AI-Powered APIs: Applications and Challenges',
                    'Blockchain API Development: Enabling Decentralized Applications',
                    'Latest Updates in OpenAPI and AsyncAPI Standards: How They Impact API Design',
                    'Building Event-Driven APIs: Patterns and Best Practices for Scalable Systems',
                ],
            },
            {
                title: 'API Security and Event-Driven APIs',
                topics: [
                    'API Security Best Practices: Protecting APIs from Cyber Threats and Data Breaches',
                    'Compliance Requirements for APIs: HIPAA, GDPR, and Other Regulations',
                    'API Security Testing: Techniques and Tools for Vulnerability Assessment',
                    'Securing Event-Driven APIs: Authentication and Authorization Patterns for Data Streams',
                    'Building Real-Time APIs with WebSockets and Server-Sent Events: Use Cases and Architectural Considerations',
                ],
            },
            {
                title: 'API Integration and Business Strategy',
                topics: [
                    'Building an Effective API Strategy: How to Align APIs with Business Goals',
                    'API Integration Best Practices for Enterprise Modernization',
                    'Implementing APIs in Healthcare: Challenges and Opportunities',
                    'The Role of APIs in Open Banking: How to Drive Innovation and Improve Customer Experience',
                    'Retail API Strategies: Leveraging APIs for Better Customer Engagement and Operational Efficiency',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>What event is about</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;